const mountDate = date => {
  let data = date, 
    day = data.getDate().toString().padStart(2, '0'), 
    month = (data.getMonth() + 1).toString().padStart(2, '0'), 
    year = data.getFullYear(); 
  return `${day}/${month}/${year}`;
}

const formatDate = date => { 
  let day, month, year;

  //eslint-disable-next-line
  let format1 = /(\d{4})[-\/](\d{2})[-\/](\d{2})/.exec(date);
  //eslint-disable-next-line
  let format2 = /(\d{2})[-\/](\d{2})[-\/](\d{4})/.exec(date);
  
  let matches = format1 ? format1 : format2; 
  
  if (matches == null) { 
    return false; 
  } 
  
  if (!format1) {
    day = matches[1]; 
    month = matches[2]; 
    year = matches[3]; 
  } else {
    day = matches[3]; 
    month = matches[2]; 
    year = matches[1];
  }

  let data = new Date(`${year}-${month}-${day} 00:00:00`); 
  let newFormat = mountDate(data); 
  return newFormat; 
} 

export default formatDate;